import { render, staticRenderFns } from "./ServicesCategoriesInfo.vue?vue&type=template&id=194c8eb3&scoped=true"
import script from "./ServicesCategoriesInfo.vue?vue&type=script&lang=js"
export * from "./ServicesCategoriesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c8eb3",
  null
  
)

export default component.exports